import { createFileRoute } from "@tanstack/react-router";
import { AwesomePlainTextAccountingComponent } from "@/pages/awesome-plain-text-accounting";
import { head, loader } from "@/pages/awesome-plain-text-accounting.meta";

export const Route = createFileRoute("/$locale/awesome-plain-text-accounting")({
  loader,
  head,
  component: AwesomePlainTextAccountingComponent,
});
